import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../components/Forms/SimpleTextField'
const TreatmentText = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <SimpleTextField
      value={moduleValues?.['Treatment Notes'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Treatment Notes']: e.target.value,
        }))
      }
      label="Treatment Notes"
      multiline
      minRows={2}
    />
  </Grid>
)

export default TreatmentText
